export default {
  months: {
    january: 'Январь',
    february: 'Февраль',
    march: 'Март',
    april: 'Апрель',
    may: 'Май',
    june: 'Июнь',
    july: 'Июль',
    august: 'Август',
    september: 'Сентябрь',
    october: 'Октябрь',
    november: 'Ноябрь',
    december: 'Декабрь',
  },
  days: {
    monday: 'Пн',
    tuesday: 'Вт',
    wednesday: 'Ср',
    thursday: 'Чт',
    friday: 'Пт',
    saturday: 'Сб',
    sunday: 'Вс',
  },
  labels: {
    month: 'Месяц',
    year: 'Год',
    dayOfWeek: 'День недели',
    set: 'Задать',
    format: 'дд.мм.гггг',
    formatWithTime: 'дд.мм.гггг чч:мм'
  },
}
